import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex)
const state = {
  // loading全局开关
  LOADING: false,
  langFlag: false, // 中英文切换
  lang: 'EN',
  title: '',//网站标题
}

const store = new Vuex.Store({
  state,
  actions,
  mutations: {
    ...mutations,
    setLang (_state, langFlag) {
      _state.langFlag = langFlag;
    },
    setLa (_state, lang) {
      _state.lang = lang;
    },
    setTit (_state, title) {
      _state.title = title;
    }
  },
  getters,
  modules: {

  }
  // state: {
  //   // loading全局开关
  // 	LOADING: false
  // },
  // mutations: {
  // 	showLoading(state){
  //     state.LOADING = true
  //   },
  //   hideLoading (state) {
  //       state.LOADING = false
  //   }
  // },
  // modules: {},
  // getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js